/*slider.js*/
/* import Flickity*/
import Flickity from 'flickity';

let sliderContainer = document.querySelectorAll('[slider-container=""]');
let sliderContainerWrap = document.querySelectorAll('[slider-container="wrapAround"]');
let slider= [];

let isFlickity

const setSlider = () => {

  sliderContainer = document.querySelectorAll('[slider-container=""]');
  sliderContainerWrap = document.querySelectorAll('[slider-container="wrapAround"]');

  // standard page slider
  if (sliderContainer.length) {

    sliderContainer.forEach((container, i) => {

      slider[i] = new Flickity(container, {
        // options
        cellAlign: 'center',
        imagesLoaded: true,
        lazyLoad: 2,
        prevNextButtons: false,
        pageDots: false
      });

      setAutoplay(slider[i]);
      container.setAttribute('data-slider-count', [i]);
  
    })

    isFlickity = true

  }

  // project page slider
  if (sliderContainerWrap.length) {

    sliderContainerWrap.forEach((container, i) => {

      slider[i] = new Flickity(container, {
        // options
        cellAlign: 'center',
        wrapAround: true,
        imagesLoaded: true,
        lazyLoad: 2,
        prevNextButtons: false,
        autoPlay: 1500,
        pauseAutoPlayOnHover: false
        // pageDots: false
      });

      setAutoplay(slider[i]);
      container.setAttribute('data-slider-count', [i]);

      slider[i].on( 'dragStart', function( event, pointer, moveVector ) {
        document.body.classList.add('js-isDragging');
      });
      slider[i].on( 'dragEnd', function( event, pointer, moveVector ) {
        setTimeout(() => {
          document.body.classList.remove('js-isDragging');
        }, 250)
      });

    })

    isFlickity = true

  }

}

const destroySlider = () => {

  if ( isFlickity ) {
    //destroy slider
    // slider.destroy();
    // following code is untested -->
    if (sliderContainer.length) {
      sliderContainer.forEach((container, i) => {
        slider[i].destroy();
      })
    }

    if (sliderContainerWrap.length) {
      sliderContainerWrap.forEach((container, i) => {
        slider[i].destroy();
      })
    }

  }

  isFlickity = false

}

function setAutoplay(el) {

  const config = {
    root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
    // rootMargin: rootMargin + 'px',
    rootMargin: '0px',
    // threshold: 0.5
    threshold: 0
  };

  let isLeaving = false;

  let observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // we are ENTERING the "capturing frame". Set the flag.
        isLeaving = true;

        /* currently observer slider */
        let count = entry.target.dataset.sliderCount
        
        //start autoplay on carousel
        slider[count].playPlayer();


      } else if (isLeaving) {
        // we are EXITING the "capturing frame"
        isLeaving = false;

        /* currently observer slider */
        let count = entry.target.dataset.sliderCount

        //stop autoplay on carousel
        slider[count].stopPlayer();

      }
    })
  }, config);

  observer.observe(el.element)
  // el.forEach(element => { observer.observe(element) });

}

export {setSlider,destroySlider};